import { defineCustomElement } from 'vue';
import BotaoCarregarMais from '../../../src/vue/shared/filtro/components/BotaoCarregarMais.vue';
import plugins from '../../../src/vue/shared/filtro/plugins';
try {
  if (!customElements.get('botao-carregar-mais-itens')) {
    const BotaoCarregarMaisElement = defineCustomElement(BotaoCarregarMais, {
      shadowRoot: false,
      configureApp(app) {
        app.use(plugins);
      }
    });
    customElements.define('botao-carregar-mais-itens', BotaoCarregarMaisElement);
  }
} catch (error) {
  console.error('Falha ao definir o componente customizado:', error);
}
